(function(){
  'use strict';

  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  function desktop(){return window.matchMedia?window.matchMedia('(min-width:1025px)').matches:window.innerWidth>=1025;}

  function scrollToTechnical(event){
    var link=event.currentTarget;
    var target=document.getElementById('mg2-product-technical');
    if(!target)return;
    event.preventDefault();

    /* The technical block uses content-visibility for performance.  Force it
       measurable before calculating the destination, otherwise Chromium can
       stop at the preceding intrinsic placeholder instead of the real section. */
    target.style.setProperty('content-visibility','visible','important');

    window.requestAnimationFrame(function(){
      var header=document.querySelector('[data-mg2-header]');
      var headerHeight=header?Math.ceil(header.getBoundingClientRect().height):0;
      var y=window.scrollY+target.getBoundingClientRect().top-Math.max(18,headerHeight+18);
      window.scrollTo({top:Math.max(0,y),behavior:'smooth'});
      if(history&&history.replaceState)history.replaceState(null,'','#mg2-product-technical');
    });
  }

  function initSpecLinks(){
    if(!desktop())return;
    document.querySelectorAll('.lbx101-spec-shortcut, .mg2-pdp-spec-link[href="#mg2-product-technical"]').forEach(function(link){
      if(link.dataset.lbx102SpecReady==='1')return;
      link.dataset.lbx102SpecReady='1';
      link.addEventListener('click',scrollToTechnical);
    });
  }

  function init(){initSpecLinks();}
  ready(init);
  document.addEventListener('shopify:section:load',init);
})();
